import {
  LOCATION_PRIMER_SUPPRESSION_MS,
  LOCATION_PRIMER_SUPPRESSION_STORAGE_KEY,
  PUSH_NOTIFICATION_PRIMER_SUPPRESSION_MS,
  PUSH_NOTIFICATION_PRIMER_SUPPRESSION_STORAGE_KEY,
} from '../permissions.machine.constants';
import { permissionsStorage } from '../permissions.machine.storage';

// ─── Internal Actions ────────────────────────────────────────────────────────

export const persistPushNotificationSuppressedUntil = () => {
  permissionsStorage.set(
    PUSH_NOTIFICATION_PRIMER_SUPPRESSION_STORAGE_KEY,
    Date.now() + PUSH_NOTIFICATION_PRIMER_SUPPRESSION_MS,
  );
};

export const persistSuppressedUntil = () => {
  permissionsStorage.set(
    LOCATION_PRIMER_SUPPRESSION_STORAGE_KEY,
    Date.now() + LOCATION_PRIMER_SUPPRESSION_MS,
  );
};

// ─── External Actions ────────────────────────────────────────────────────────

export const onPushNotificationPrimerShow = () => undefined;

export const onRequestPushNotificationPermission = () => undefined;

export const onSkipPushNotificationPermission = () => undefined;

export const onLocationPrimerShow = () => undefined;

export const onRequestLocationPermission = () => undefined;

export const onSkipLocationPermission = () => undefined;
